import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'prg-label-icon',
  templateUrl: './label-icon.component.html',
  styleUrls: ['./label-icon.component.less']
})
export class LabelIconComponent implements OnInit {

  @Input() icon: string;
  @Input() title: string;
  @Input() subtitle: string;

  @Input() showText: boolean;
  @Input() textClass: string;
  @Input() titleClass: string;
  @Input() subtitleClass: string;

  constructor() {
    this.icon = '';
    this.title = '';
    this.subtitle = '';
    this.showText = true;
    this.titleClass = '';
    this.subtitleClass = '';
    this.textClass = '';
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/label-icon/label-icon.component.ts